import { NavigationItemResponse } from './types';
import apiClient from '../../../lib/apiClient';

const navigationQueryKey = ['navigation'];
const fetchConfig: () => Promise<NavigationItemResponse[]> = async () => {
  const navigationResponse = await apiClient.fetch(location.href, `/api/navigationtree`);

  return navigationResponse.json();
};

export const navigationQueryOptions = {
  queryKey: navigationQueryKey,
  queryFn: () => fetchConfig(),
  staleTime: Infinity,
};
